import { useEffect, useRef, useState } from 'react';

export default function LabelsPicker({ selectedLabels, onChange, availableLabels }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  function toggle(label) {
    if (selectedLabels.includes(label)) {
      onChange(selectedLabels.filter(l => l !== label));
    } else {
      onChange([...selectedLabels, label]);
    }
  }

  const displayText = selectedLabels.length ? selectedLabels.join(', ') : 'Select label';

  return (
    <div className="lp-wrapper" ref={ref}>
      <button
        type="button"
        className="lp-trigger tcd-edit-select"
        onClick={() => setOpen(o => !o)}
        style={{ textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
      >
        <span className="lp-display">{displayText}</span>
        <span>▾</span>
      </button>
      {open && (
        <div className="lp-dropdown">
          {availableLabels.length === 0 && (
            <div className="lp-empty">No labels found</div>
          )}
          {availableLabels.map(label => (
            <label key={label} className="lp-option">
              <input
                type="checkbox"
                checked={selectedLabels.includes(label)}
                onChange={() => toggle(label)}
              />
              <span>{label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
